import * as lodash from 'lodash'
import { TemplateTypes } from './template-types'

export const availableTemplateTypes: {
  id: TemplateTypes
  name: string
  icon: string
  colorClass: string
  tooltip: string
}[] = [
  {
    id: TemplateTypes.Contract,
    name: $localize`Contract`,
    icon: 'cs-icon cs-icon-file-signature2',
    colorClass: 'text-success',
    tooltip: $localize`A contract is a legal template which requires the recipient(s) to sign and fill in requested fields. Contracts can contain text boxes, checkboxes, and data dictionary codes.`,
  },
  {
    id: TemplateTypes.Form,
    name: $localize`Form`,
    icon: 'cs-icon cs-icon-fields',
    colorClass: 'text-indigo',
    tooltip: $localize`A form is a data-retrieval template that will allow the recipient(s) to fill in requested fields that will populate the guest details in your AdvanceCM account. Forms can contain textboxes, checkboxes, and data dictionary codes.`,
  },
  {
    id: TemplateTypes.Document,
    name: $localize`Printout`,
    icon: 'cs-icon cs-icon-printer2',
    colorClass: 'text-info',
    tooltip: $localize`A printout is a read-only, electronic template containing fields that are already filled with data from your AdvanceCM account. Documents can contain data dictionary codes.`,
  },
]

export const emailSubjectByTemplateType = {
  [TemplateTypes.Contract]: $localize`Your signature is requested`,
  [TemplateTypes.Document]: $localize`Here is your document`,
  [TemplateTypes.Form]: $localize`You have been requested to complete a form`,
}

export function getTemplateTypeLabel(type: TemplateTypes): string {
  return lodash.find(availableTemplateTypes, { id: type })?.name
}
